import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';
import type { EnvHealthSimulate } from './api/types';

type SimulateValue = NonNullable<EnvHealthSimulate>;

const $simulate = atom<SimulateValue | undefined>(undefined);

export function useWorkspaceHealthSimulation() {
  const simulate = useStore($simulate);
  const handleSetSimulate = (value: SimulateValue | undefined) => $simulate.set(value);

  return { simulate, handleSetSimulate };
}
